var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bkr-cc" },
    [
      _c("div", { staticClass: "input-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.searchString,
              expression: "searchString",
            },
          ],
          ref: "searchInput",
          staticClass: "search-input flex-grow-1 px-2 py-2 bkmSearchbox",
          attrs: {
            type: "search",
            id: "bk-searchbox-1",
            enterkeyhint: "search",
            autofocus: _vm.isShopBuilder,
            "aria-label": _vm.$translate("Ceres::Template.headerSearchTerm"),
            placeholder: "Suchbegriff eingeben...",
          },
          domProps: { value: _vm.searchString },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.searchString = $event.target.value
              },
              function ($event) {
                return _vm.onValueChanged($event.target.value)
              },
            ],
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.search()
            },
            focus: function ($event) {
              _vm.isSearchFocused = true
            },
            blur: function ($event) {
              return _vm.onBlurSearchField($event)
            },
          },
        }),
        _vm._v(" "),
        _vm.searchString.length
          ? _c(
              "button",
              {
                staticClass: "clearField",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.clearInput()
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "18",
                      height: "18",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                    },
                  },
                  [
                    _c("line", {
                      attrs: { x1: "18", y1: "6", x2: "6", y2: "18" },
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: { x1: "6", y1: "6", x2: "18", y2: "18" },
                    }),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "input-group-append d-none" }, [
          _c(
            "button",
            {
              staticClass: "search-submit btn btn-bkm bkmSearchbutton",
              attrs: { "aria-label": "Suchen", type: "submit" },
              on: {
                click: function ($event) {
                  return _vm.search()
                },
              },
            },
            [
              _c("icon", {
                staticClass: "fa-fw",
                attrs: { icon: "search", loading: _vm.autocompleteIsLoading },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm.isSearchFocused
        ? [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      (_vm.searchString.length >= _vm.searchMinLength &&
                        _vm.hasInitialInput) ||
                      _vm.$ceres.isShopBuilder ||
                      _vm.isSearchFocused,
                    expression:
                      "(searchString.length >= searchMinLength && hasInitialInput) || $ceres.isShopBuilder || isSearchFocused",
                  },
                ],
              },
              [
                _vm._t("autocomplete-suggestions", function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "autocomplete-results bg-white" },
                      [
                        _c("search-suggestion-item", {
                          attrs: {
                            "is-loading": _vm.autocompleteIsLoading,
                            "padding-classes": "px-2",
                            "show-images": false,
                            "suggestion-type": "suggestion",
                            "show-additional-information": true,
                            "show-count": false,
                          },
                        }),
                        _vm._v(" "),
                        _c("search-suggestion-item", {
                          attrs: {
                            "is-loading": _vm.autocompleteIsLoading,
                            "padding-classes": "px-2",
                            "show-images": true,
                            "suggestion-type": "item",
                            "show-additional-information": false,
                            "show-count": false,
                          },
                        }),
                        _vm._v(" "),
                        _c("search-suggestion-item", {
                          attrs: {
                            "is-loading": _vm.autocompleteIsLoading,
                            "padding-classes": "px-2",
                            "show-images": false,
                            "suggestion-type": "category",
                            "show-additional-information": true,
                            "show-count": false,
                          },
                        }),
                        _vm._v(" "),
                        _c("search-suggestion-item", {
                          attrs: {
                            "is-loading": _vm.autocompleteIsLoading,
                            "padding-classes": "px-2",
                            "show-images": true,
                            "suggestion-type": "brands",
                            "show-additional-information": true,
                            "show-count": false,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                }),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }